import React, { forwardRef } from 'react';
import { type Types } from '@fiverr-private/theme';
import Flex from '../Flex';

const Wrap = forwardRef<HTMLElement, Types.FlexLayoutProps>(
  (
    {
      children,
      gap = { default: '3' },
      wrap = { default: 'wrap' },
      dataTrackTag = 'wrap',
      ...restProps
    }: Types.FlexLayoutProps & Pick<Types.BoxType, 'dataTrackTag' | 'dataTrackValue'>,
    ref
  ) => (
    <Flex dataTrackTag={dataTrackTag} ref={ref} gap={gap} wrap={wrap} {...restProps}>
      {children}
    </Flex>
  )
);

Wrap.displayName = 'Wrap';

export default Wrap;
